import i18n from '@/plugins/i18n';
import { animalLanguagesCountryCodes } from '@/config/animal_translations';


export const appLanguages = [...i18n.global.availableLocales].sort();
export const animalLanguages = [...animalLanguagesCountryCodes].sort();
